import { render, staticRenderFns } from "./measurementLayout.vue?vue&type=template&id=51bdd54b&"
import script from "./measurementLayout.vue?vue&type=script&lang=js&"
export * from "./measurementLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports